import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";
import { listingsV2QueryOptions } from "@/lib/queries/publicData";
import { getAllCities } from "@/data/cities";
import { isKnownLocality } from "@/utils/cityArea";
import { citySlug } from "@/utils/citySlug";

// Legacy /city/{city} → 301 to the canonical /masini-de-vanzare-{city}, only
// when that target resolves (same locality check as the target route).
// Unmappable slugs return 404 instead of redirecting to a 404.
export const Route = createFileRoute("/city/$citySlug/")({
  loader: async ({ context, params }) => {
    const slug = citySlug(params.citySlug);
    const rows = await context.queryClient
      .ensureQueryData(listingsV2QueryOptions({ country_code: "RO", limit: 5000 }))
      .catch(() => undefined);
    const knownSlugs = getAllCities("RO").map((c) => c.slug);
    const known = knownSlugs.includes(slug) || (Array.isArray(rows) && isKnownLocality(slug, knownSlugs, rows));
    if (!slug || !known) throw notFound();
    throw redirect({ href: `/masini-de-vanzare-${slug}`, statusCode: 301 });
  },
  head: ({ params }) => routeHead("/city/$citySlug/", params as Record<string, string>),
  component: () => null,
});
